import React from "react";
import { useParams } from "react-router-dom";
import OratorTemplate from "./OratorTemplate";
import { orators_details_map } from "../../utils/Orators"; 

const OratorDetails = () => {
  const { id } = useParams();
  const orator = orators_details_map[id];

  if (!orator) {
    return (
      <div className="text-center mt-20 text-xl font-semibold">
        Orator not found
      </div>
    );
  }

  return <OratorTemplate {...orator} />;
};

export default OratorDetails;
